import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HistoryComponent } from './history/history.component';
import { MuseumComponent } from './museum/museum.component';
import { HonoursComponent } from './honours/honours.component';
import { RecordsComponent } from './records/records.component';
import { GroundComponent } from './ground/ground.component';

const routes: Routes = [
  {path: "history", component: HistoryComponent},
  {path: "museum", component: MuseumComponent},
  {path: "honours", component: HonoursComponent},
  {path: "records", component: RecordsComponent},
  {path: "ground", component: GroundComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HistoryRoutingModule { }
